
export function getMessages (state) {
    return state.messages
}

export function getFiles (state) {
    return state.filesUpdater
}

export function getActivityList (state) {
    return state.activityList
}
